import { createFileRoute } from '@tanstack/react-router';

import { StaffDetail } from '@/features/staff/StaffDetail';

export const Route = createFileRoute('/_authenticated/staff/$staffId')({
  component: function StaffDetailPage() {
    const { staffId } = Route.useParams();
    return <StaffDetail staffId={staffId} />;
  },
});
